















import Vue from "vue";

type HamburgerTransition = "default";

interface Props {
  // Define if the hamburger has to display the cross
  active: boolean;
  transition: HamburgerTransition;
}

/**
 * @see Squeeze https://jonsuh.com/hamburgers/
 */
export default Vue.extend<Props>({
  name: "JzHamburger",
  functional: true,

  props: {
    active: { type: Boolean, default: false },
    transition: {
      type: String as () => HamburgerTransition,
      default: "default"
    }
  }
});
